import { render, staticRenderFns } from "./Orderreturn.vue?vue&type=template&id=ca8fa6fa&scoped=true"
import script from "./Orderreturn.vue?vue&type=script&lang=js"
export * from "./Orderreturn.vue?vue&type=script&lang=js"
import style0 from "./Orderreturn.vue?vue&type=style&index=0&id=ca8fa6fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8fa6fa",
  null
  
)

export default component.exports